import SmotriButton from "@components/SmotriButton";
import { RefreshCcw } from "lucide-react";
import backgroundImage from "@images/Avatar.png";
import logoImage from "@images/avatar-logo.png";

export default function ShowcaseSection() {
  return (
    <section className="home-showcase w-full bg-black px-4 py-6 sm:px-8 sm:py-10 xl:px-20">
      <div
        className="home-showcase-card relative mx-auto h-[720px] w-full max-w-[1760px] overflow-hidden rounded-xl bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div
          className="absolute inset-0 bg-[linear-gradient(247.91deg,rgba(0,0,0,0)_4.08%,rgba(0,0,0,0)_50.97%,rgba(0,0,0,0.0233106)_59.07%,rgba(0,0,0,0.38)_67.2%),linear-gradient(180deg,rgba(0,0,0,0)_42%,rgba(0,0,0,0.82)_100%),rgba(255,255,255,0.1)]"
          aria-hidden="true"
        />

        <div className="justify-between ">
          <div className="home-showcase-copy absolute left-12 top-[483px] z-10 flex h-[195.28px] w-[822px] flex-col items-start gap-6">
            <div className="flex h-[93.28px] w-[298px] flex-col items-start justify-center rounded-[16.5173px]">
              <img
                className="h-[93.28px] w-[298px] object-contain object-left"
                src={logoImage}
                alt="Avatar"
                draggable="false"
              />
            </div>

            <div className="flex h-[78px] w-[822px] flex-col items-start gap-3">
              <div className="home-showcase-description inter-r flex h-12 w-[637px] items-center text-base leading-[150%] tracking-[-0.01em] text-white/90">
                это бесплатный сервис, который позволяет смотреть сериалы и
                фильмы вместе с другими людьми на любой крупной стриминговой
                платформе, в идеальной
              </div>
              <div className="inter-m flex h-[18px] w-[822px] items-center text-[15px] leading-[120%] tracking-[-0.01em] text-white/50">
                2021 , Фильм
              </div>
            </div>
          </div>

          <div className="home-showcase-actions absolute right-12 top-[621px] z-10 flex h-[57px] w-64 flex-row items-end gap-2">
            <SmotriButton className="inter-m items-start leading-[140%]">
              Смотреть фильм
            </SmotriButton>
            <button
              className="flex h-[57px] w-16 items-center justify-center gap-2 rounded-2xl bg-white/[0.12] px-[18px] py-3 backdrop-blur-[5px]"
              type="button"
              aria-label="Обновить"
            >
              <RefreshCcw
                className="h-7 w-7 text-white/60"
                strokeWidth={1.5}
                aria-hidden="true"
              />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
